/*
 * Ryan O'Dowd
 * 2024-05-17
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    infoButton: {
      fontSize: 20,
      marginLeft: 8,
      color: colors.primary,
    },
    errorText: {
      color: colors.alert,
    },

    adminSettingsWrapper: {
      backgroundColor: colors.primaryExtraLight,
    },
    adminOptionsInner: {
      flex: 1,
    },
  };
};

export default getStyles;
